//only public props
//don't put API keys and secrets and other confidential info in this file
//use .env files for confidential info

const APP_ENV = String(process.env.REACT_APP_ENV).trim();

const ENV_TYPES = {
    DEV: 'dev',
    PROD: 'prod',
    LOCAL: 'local'
};

//true if ENV is PROD
export const isEnvProd = () => {
    return APP_ENV === ENV_TYPES.PROD;
};

export const URL_CONFIG = {
    'DASHBOARD_URLS': 'login,logout,dashboard',
    'BASE_URLS': APP_ENV === ENV_TYPES.LOCAL ? 'localhost/' : process.env.REACT_APP_B_URL
};

console.log("E " + APP_ENV);
// console.log(URL_CONFIG);

// console.log("AWS");
// console.log(process.env.REACT_APP_AWS_ACCESS_KEY);
// console.log(process.env.REACT_APP_AWS_SECRET_KEY);
